import "./index.css";

/*
  data-color:
  - "" (for all)
  - blue
  - orange
  - yellow 
*/

export function setupNews() {
  const container = document.querySelector(".container-news");

  if (container == null) {
    return;
  }

  const yearSelect = container.querySelector(
    ".container-news-filter-year select"
  ) as HTMLSelectElement;

  filterItem(yearSelect.value, getActiveColor());

  yearSelect.addEventListener("change", () => {
    filterItem(yearSelect.value, getActiveColor());
  });

  container
    .querySelector(".container-news-filter-category")
    ?.addEventListener("click", (e) => {
      const li = (e.target as HTMLElement).closest("li");
      if (li) {
        const color = li.getAttribute("data-color") || "";
        setActiveColor(color);
        filterItem(yearSelect.value, color);
      }
    });

  // expired news
  container
    .querySelectorAll(".container-news-list-item[data-expired]")
    .forEach((item) => {
      const expired = Number(item.getAttribute("data-expired")) * 1000;
      const date = new Date(expired);
      if (expired > 0 && new Date() > date) {
        // set expired text: `掲載期限：yyyy年mm月dd日`
        item.setAttribute(
          "data-expired-text",
          `掲載期限：${date.getFullYear()}年${
            date.getMonth() + 1
          }月${date.getDate()}日`
        );
        // remove expired links
        item
          .querySelectorAll(".container-news-list-item-link a")
          .forEach((item) => {
            item.removeAttribute("href");
            item.setAttribute("data-popup-event", "popup-open");
            item.setAttribute("data-popup-id", "news-expired");
          });
      }
    });

  container.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (target.closest(".container-news-list-item-link a")) {
      const expiredText = target
        .closest(".container-news-list-item")
        ?.getAttribute("data-expired-text");
      if (expiredText) {
        e.preventDefault();
        const textElement = document.querySelector(
          ".container-news-expired .element-popup-content"
        ) as HTMLElement;
        textElement.innerHTML = `<p>${expiredText}</p>` || "";
      }
    }
  });

  function getActiveColor(): string {
    const li = container?.querySelector(
      ".container-news-filter-category li[data-active]"
    ) as HTMLLIElement;
    return li.getAttribute("data-color") || "";
  }

  function setActiveColor(color: string) {
    const prev = container?.querySelector(
      ".container-news-filter-category li[data-active]"
    ) as HTMLLIElement;
    const li = container?.querySelector(
      `.container-news-filter-category li[data-color="${color}"]`
    ) as HTMLLIElement;
    prev.removeAttribute("data-active");
    li.setAttribute("data-active", "");
  }

  function filterItem(year: string, color: string) {
    const items = container?.querySelectorAll(
      ".container-news-list-item"
    ) as NodeListOf<HTMLElement>;
    items.forEach((item) => {
      if (
        item.getAttribute("data-year") === year &&
        (item.getAttribute("data-color") === color || color === "")
      ) {
        item.setAttribute("data-visible", "");
      } else {
        item.removeAttribute("data-visible");
      }
    });
  }
}
